import * as React from "react";

function ChervonIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={8} height={13} fill="none" {...props}>
      <path
        d="M1.166 12.917a.908.908 0 01-.659-.258.884.884 0 010-1.29L5.35 6.5.507 1.657a.884.884 0 010-1.29.884.884 0 011.29 0l5.5 5.501a.884.884 0 010 1.29l-5.5 5.501a.889.889 0 01-.63.258z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoChervonIcon = React.memo(ChervonIcon);
export default MemoChervonIcon;
